import React from 'react';
import styled from 'styled-components';

const LegendContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #E2FFE4;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
  border-top: 1px solid #2C3E50;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LegendContent = styled.div`
  display: flex;
  justify-content: center;
  gap: 3rem;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  max-width: min(1400px, 100%);
  margin: 0 auto;
  min-width: 0;

  @media (max-width: 1200px) {
    gap: 2rem;
  }

  @media (max-width: 900px) {
    gap: 1.5rem;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 0.7rem;
  }
`;

const LegendGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  min-width: 0;

  @media (max-width: 900px) {
    gap: 0.5rem;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.7rem;
  color: #2C3E50;
  white-space: nowrap;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-transform: uppercase;
  min-width: 0;
  letter-spacing: -0.3px;

  @media (max-width: 768px) {
    font-size: 0.7rem;
  }
`;

const ColorBox = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${props => props.color};
  border-radius: 50px;
  border: 1px solid #2C3E50;

  @media (max-width: 900px) {
    width: 12px;
    height: 12px;
  }
  
  @media (max-width: 768px) {
    width: 8px;
    height: 8px;
  }
`;

const VerticalDisclaimer = styled.div`
  position: fixed;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  letter-spacing: -0.3px;
  color: #2C3E50;
  writing-mode: vertical-rl;
  text-align: center;
  text-orientation: mixed;
  transform: ${props => props.side === 'left' ? 'rotate(180deg)' : 'none'};
  ${props => props.side === 'left' ? 'left: 5px;' : 'right: 5px;'}
  padding: 10px;
  border-radius: 4px;
  top: 50%;
  transform: ${props => props.side === 'left' ? 'rotate(180deg) translateY(50%)' : 'translateY(-50%)'};
  height: fit-content;
  white-space: nowrap;
  line-height: 1;
  font-weight: 400;
`;

const Legend = () => {
  return (
    <>
      <VerticalDisclaimer side="left">
        FYI: these are just flowers - not legal advice - all commentary is AI generated
      </VerticalDisclaimer>
      <VerticalDisclaimer side="right">
        The data is 15 minute delayed so it might be slightly off
      </VerticalDisclaimer>
      <LegendContainer>
        <LegendContent>
          <LegendGroup>
            <LegendItem>
              <ColorBox color="#59FF38" />
              <span>Price Up</span>
            </LegendItem>
            <LegendItem>
              <ColorBox color="#FC43D7" />
              <span>Price Down</span>
            </LegendItem>
            <LegendItem>
              <ColorBox color="#8368F1" />
              <span>No Change</span>
            </LegendItem>
          </LegendGroup>
          <LegendGroup>
            <LegendItem>
              <span>Petal Size : Volatility</span>
            </LegendItem>
            <LegendItem>
              <span>Center Size : Market Cap</span>
            </LegendItem>
            <LegendItem>
              <span>Number of Petals : Volume</span>
            </LegendItem>
          </LegendGroup>
        </LegendContent>
      </LegendContainer>
    </>
  );
};

export default Legend; 